export default __webpack_public_path__ + "static/MachineSound-d573131965f8ff925213a4ad09c9971c.jpg";